import React from "react";
import { createBrowserRouter, type RouteObject } from "react-router-dom";
import App from "../App";

// Keep the existing component-route tree intact while moving the application
// onto React Router's Data Router runtime. Feature routes can migrate to route
// objects incrementally; in the meantime the catch-all hands every URL to App.
export const appRouteObjects: RouteObject[] = [
  {
    path: "*",
    element: <App />,
  },
];

// Data routers must be created once outside the React render tree.
export const appRouter = createBrowserRouter(appRouteObjects);
